export default __webpack_public_path__ + "static/media/fab1.aabe666e.jpg";